import { Card, CardBody, Col, Row } from "reactstrap";

import AssessmentTimerCard from "../../../../container/AssessmentTimer";
import { Question } from "../../../../utils/Constant";
import { questionTypes } from "../../../../utils/helper/helper";
import useIsMobile from "../../../../utils/helper/responsive";
import {
  getFromSessionStorage,
  QUESTION_PREVIEW_DATA,
} from "../../../../utils/helper/sessionStorageUtils";
import Header from "../../../LearningAssessment/Header";
import FreeText from "../../../LearningAssessment/Questions/FreeText";
import MultiChoise from "../../../LearningAssessment/Questions/MultiChoise";
import SingleChoise from "../../../LearningAssessment/Questions/SingleChoise";

const QuestionPreview = () => {
  const question = getFromSessionStorage(QUESTION_PREVIEW_DATA);
  const isMobile = useIsMobile();

  const renderQuestionComponent = (questionNumber: string) => {
    const question_text = question?.question_text;
    const question_type = question?.question_type;
    const options = question?.options;

    switch (question_type) {
      case questionTypes.multiple_choice:
        return (
          <MultiChoise
            questionId={question.question_id}
            title={question_text}
            questionNumber={questionNumber}
            options={options}
            handleChange={() => null}
            mediaUrl={question.media_url}
            isChecked={() => null}
            extension={question.extension}
            fileName={question.fileName}
          />
        );

      case questionTypes.single_select:
        return (
          <SingleChoise
            questionId={question.question_id}
            title={question_text}
            questionNumber={questionNumber}
            options={options}
            handleChange={() => null}
            mediaUrl={question.media_url}
            isChecked={() => null}
            extension={question.extension}
            fileName={question.fileName}
          />
        );

      case questionTypes.open_text:
        return (
          <FreeText
            questionId={question.question_id}
            title={question_text}
            questionNumber={questionNumber}
            handleChange={() => null}
            mediaUrl={question.media_url}
            extension={question.extension}
            fileName={question.fileName}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div>
      <Header name={question?.name} />
      <Row className="learning-assessment justify-content-center">
        {isMobile && (
          <Col xs="12">
            <AssessmentTimerCard
              time={{
                hours: 0,
                minutes: 0,
                seconds: 0,
              }}
            />
          </Col>
        )}
        <Col xs="12" md="7" className="mb-4">
          <Card>
            <CardBody>{renderQuestionComponent(`${Question} 1`)}</CardBody>
          </Card>
        </Col>
        {!isMobile && (
          <Col xs="12" md="4">
            <AssessmentTimerCard
              time={{
                hours: 0,
                minutes: 0,
                seconds: 0,
              }}
            />
          </Col>
        )}
      </Row>
    </div>
  );
};

export default QuestionPreview;
